export const LIST_PLAN_FIRMS_SUCCESS = 'LIST_PLAN_FIRMS_SUCCESS';
export const LIST_PLAN_FIRMS_FAILURE = 'LIST_PLAN_FIRMS_FAILURE';

export const CREATE_PLAN_FIRM_SUCCESS = 'CREATE_PLAN_FIRM_SUCCESS';
export const CREATE_PLAN_FIRM_FAILURE = 'CREATE_PLAN_FIRM_FAILURE';

export const EDIT_PLAN_FIRM_SUCCESS = 'EDIT_PLAN_FIRM_SUCCESS';
export const EDIT_PLAN_FIRM_FAILURE = 'EDIT_PLAN_FIRM_FAILURE';

export const UPDATE_PLAN_FIRM_SUCCESS = 'UPDATE_PLAN_FIRM_SUCCESS';
export const UPDATE_PLAN_FIRM_FAILURE = 'UPDATE_PLAN_FIRM_FAILURE';

export const DELETE_PLAN_FIRM_SUCCESS = 'DELETE_PLAN_FIRM_SUCCESS';
export const DELETE_PLAN_FIRM_FAILURE = 'DELETE_PLAN_FIRM_FAILURE';
